import React from "react";
import { View } from "react-native";
import { EmptyStateSubtitleText, SectionTitle } from "@louise/moon-ui";

/**
 * Shared empty state for clinic sections we want to keep visible even when we
 * have no data (pricing, insurance, financing). Says plainly that we don't have
 * the info instead of the section silently disappearing.
 */
type Props = {
  /** Bold sub-heading, matches the populated card's heading (e.g. "Financing options"). */
  title?: string;
  /** The "we don't have info" message. */
  message: string;
  /** Retained for backwards-compatible callers; empty states no longer show a contact CTA. */
  contactUrl?: string;
  testID?: string;
};

export default function ClinicInfoEmptyState({
  title,
  message,
  testID,
}: Props) {
  return (
    <View testID={testID} style={{ gap: 8 }}>
      {title ? <SectionTitle level="subsection">{title}</SectionTitle> : null}
      <EmptyStateSubtitleText style={{ marginTop: 0 }}>
        {message}
      </EmptyStateSubtitleText>
    </View>
  );
}
